import React from 'react';
import PendingTasksWidget from './PendingTasksWidget';

const PendingTasksWidgetBasic = () => (
  <PendingTasksWidget className="masonry-item w-[400px] h-[380px] flex flex-col" />
);

export default PendingTasksWidgetBasic;
